import { useSelector, shallowEqual } from 'react-redux';
import NsContent from 'components/common/ns-content/NsContent';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { useNavigation } from 'hooks/useNavigation';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { NsxAddressSelector } from 'components/common/nsx-address-selector/NsxAddressSelector';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { selectors as meterTypeSelectors } from 'state/meter-type/meter-type-slice';
import { NsCard } from 'components/common/ns-card/NsCard';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { HighDemandAlert } from 'components/common/error/components/HighDemandAlert';

const { selectIsLoading: selectIsLoadingMeterType } = meterTypeSelectors;

export const testId = 'findAddressTestId';

export const FindAddress = () => {
  const isLoadingMeterType = useSelector(
    selectIsLoadingMeterType,
    shallowEqual
  );
  const { next, eventTypes } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  const handleLogin = () => {
    next({ eventType: eventTypes.LOGIN });
  };

  if (isLoadingMeterType) {
    return <NsStopgap />;
  }

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <HighDemandAlert />
        <NsTitle title="Please enter your address" />
        <NsColumn basketballcourt="2">
          <NsxAddressSelector handleGoNext={handleGoNext} />
          <div>
            <NsCard
              type="support"
              heading="Already a British Gas customer or already told us you’ve moved out?"
              action={
                <NsSecondaryCta onClick={handleLogin}>
                  Login to your account
                </NsSecondaryCta>
              }
            >
              Access your account online to get a more accurate quote.
            </NsCard>
          </div>
        </NsColumn>
      </NsContent>
    </NsPanel>
  );
};

export default FindAddress;
